module.exports = __webpack_public_path__ + "static/Karla-BoldItalic-17f8a645015756768592e12b12219220.ttf";